import {
    get,
    post,
} from "../ApiDecorator";

/**
 * 思维日志 · 个人成长报告（/phase/thinkingLog/growthReport）
 */
const LogReport = {
    /** POST 通过文件 identifier 导入日志报告并创建待发布记录 */
    upload(data) {
        return post("/course/phase/thinkingLog/growthReport/upload", data);
    },
    /** GET 日志报告列表 */
    list(data) {
        return get("/course/phase/thinkingLog/growthReport/list", data);
    },
    /** POST 编辑日志报告（可修改标题、周期，也可替换文件 identifier） */
    update(data) {
        return post("/course/phase/thinkingLog/growthReport/update", data);
    },
    /** POST 发布或取消发布（status：0 待发布，1 已发布） */
    setStatus(data) {
        return post("/course/phase/thinkingLog/growthReport/status", data);
    },
    /** POST 删除日志报告及其解析明细 */
    delete(data) {
        return post("/course/phase/thinkingLog/growthReport/delete", data);
    },
};

export default LogReport;
